module.exports = __webpack_public_path__ + "img/s-find-course.86a65b2b.svg";